/**
 * useAuth Hook
 * ============
 * Custom hook for authentication state and actions.
 * Provides a convenient interface to the AuthContext.
 */

import { useContext } from 'react';
import { AuthContext } from '../components/auth/AuthProvider';

/**
 * Hook to access authentication context
 * @returns {object} Authentication state and methods
 * @throws {Error} If used outside of AuthProvider
 */
export function useAuth() {
  const context = useContext(AuthContext);
  
  if (context === null) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
}

export default useAuth;
